import React from 'react';
import { useNavigate } from 'react-router-dom';
import { getSafeRedirectUrl } from '../utils/redirectValidation';
import { cleanupUnnecessaryCookies } from '../utils/authUtils';

const Callback = () => {
  const navigate = useNavigate();
  const redirectUrl = localStorage.getItem('redirectAfterLogin');

  React.useEffect(() => {
    // Clean up unnecessary cookies after OAuth callback
    // This runs after Amplify sets cookies, so we can remove unnecessary ones
    cleanupUnnecessaryCookies().catch(err => {
      console.warn('Error cleaning up cookies after OAuth callback:', err);
    });

    localStorage.removeItem('redirectAfterLogin');
    localStorage.removeItem('is_extension_login');
    if (redirectUrl) {
      // Validate and sanitize redirect URL to prevent open redirect attacks
      const safeUrl = getSafeRedirectUrl(redirectUrl, '/');
      window.history.pushState({}, '', safeUrl);
      navigate(safeUrl);
      
      if (safeUrl !== redirectUrl) {
        console.warn('Invalid redirect URL blocked:', redirectUrl, '-> redirecting to:', safeUrl);
      }
    }
    // Add any additional initialization logic for the authorized user here.
  }, [redirectUrl, navigate]);

  return (
    <div>
      <p>Processing callback...</p>
    </div>
  );
};

export default Callback;